import { render, staticRenderFns } from "./SetMaintain.vue?vue&type=template&id=56d87170&"
import script from "./SetMaintain.vue?vue&type=script&lang=js&"
export * from "./SetMaintain.vue?vue&type=script&lang=js&"
import style0 from "./SetMaintain.vue?vue&type=style&index=0&id=56d87170&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports